import { BasicInput } from '../withFormProps';
import React, { ChangeEvent, useCallback } from 'react';
import { useField } from '@kizi/comparator-core';

export type LastNameProps = React.ComponentPropsWithRef<typeof BasicInput> & {
  insertionFieldName: string;
  lastNameFieldName: string;
  name: string;
};

export const LastName: React.FC<LastNameProps> = ({
  insertionFieldName, // should be middlename
  lastNameFieldName, // should be surname
  name,
}) => {
  const surnamefullField = useField(name); // should be ${formName}.surnamefull
  const middlenameField = useField('*.' + insertionFieldName);
  const surnameField = useField('*.' + lastNameFieldName);
  if (!surnamefullField || !middlenameField || !surnameField) return null;
  const middlename = middlenameField.value;
  const surname = surnameField.value;
  const {
    onChange,
    value,
    errors,
    label,
    name: fieldNameWithoutFormName,
  } = surnamefullField;
  const error = errors?.join('. ');
  const fullLastName =
    middlename !== undefined ? `${middlename} ${surname}` : value ?? surname;
  const onChangeWrapper = useCallback(
    (e: ChangeEvent<any>) => {
      if (surnameField.onChange && middlenameField.onChange && onChange) {
        const splitName = e.target.value.split(' ');
        const lastIndex = splitName.length - 1;
        const newMiddlename =
          splitName.length > 1 ? splitName.slice(0, lastIndex) : '';
        const newSurname = splitName[lastIndex];
        middlenameField.onChange({
          type: 'CHANGE',
          target: {
            name: middlenameField.name,
            value: newMiddlename,
          },
        });
        surnameField.onChange({
          type: 'CHANGE',
          target: {
            name: surnameField.name,
            value: newSurname,
          },
        });
        onChange({
          type: 'CHANGE',
          target: { name: fieldNameWithoutFormName, value: e.target.value },
        });
      }
    },
    [surnameField, middlenameField, surnamefullField]
  );
  return (
    <BasicInput
      name={fieldNameWithoutFormName}
      _label={label}
      _error={error}
      onChange={onChangeWrapper}
      value={value ?? fullLastName}
    />
  );
};
